var map = {
	"./logo_changtong.png": "1t5f",
	"./logo_hewego.png": "8GfF",
	"./logo_udian.png": "0zkr",
	"./logo_xiaoxiangui.png": "+fgA",
	"./logo_ylLive.png": "rAga"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2mjt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/logo_.*\.png$
// module id = 2mjt
// module chunks = 51